import { /* pp, link, formatDate */ e } from '@helpers'

import { appStore } from '@stores'

export const useEditionStore = {

    state: ()/* : State */ => ({
        isDirty: false, // modifiée in Jetstream/FormSection.vue & captée dans helpers link() avant de changer de page
    }),

    // getters: {

    // },

    actions: {

        /**
         * Restauration d'élément (SoftDelete)
         *
         * @param {Object} item
         * @param {String} router
         * @param {String} msg      message supplémentaire, facultatif
         */
        // restoreItem({item, router, msg}){
        restoreItem(item, router, msg){

        // log('1 in restoreItem', item, router, msg)

            msg = msg ? `<p>${msg}</p>` : '';

            $q.dialog({ title: 'Confirmer la restauration',
                        ok:{label: 'Restaurer',color: 'green'}, cancel: 'Annuler', html: true,
                        message: '<p>Vous êtes sur le point de restaurer cet élément.</p>'+ msg
                }).onOk(() => {

                    proto.$inertia.post(route(router+'.restore', item.id),{
                        onFinish:() => {
                            
                            appStore().getAllUsers(true)
                        },
                        onError:() => {
                            e('ACTIONS EDITION - restoreItem', error)
                        }
                    });

                    // axios.post(`${item.restore_url}`)
                    //     .then(() => {
                    //         item.deleted_at = null
                    //     })
                    //     .catch((error) => { fn.error('ACTIONS EDITION - restoreItem', error)});
                })
        },

        /**
         * Suppression d'élément
         *
         * @param {Object} item
         * @param {String} router
         * @param {String} msg      message supplémentaire, facultatif
         * @param {Object|Array} target
         */
        // deleteItem({item, router, msg, target}){
        deleteItem(item, router, msg, title, target){

        // log('1 in deleteItem', item, router, msg, target)

            msg = msg ? `<p>${msg}</p>` : '';

            // var is_in_regex = (/user|driver/g).test(item.delete_url); // softdelete tables
            // var is_in_regex = (/user|colis/g).test(router); // softdelete tables
            var is_in_regex = router.match(/user|colis|course/g); // softdelete tables

            // var item_unsoftdeletable = (! item.deleted_at && ! (/user/g).test(item.delete_url) );  // tables softdelete: users
            var item_destroyable = (item.deleted_at || (! item.deleted_at && ! is_in_regex) );  // suppression définitive

            let isArchivage = (router == 'course') && ! item.deleted_at && item.validated_at


            $q.dialog({ title: title ?? 'Confirmer l'+(item_destroyable ? 'a Suppression Définitive' : (!isArchivage ? 'a Désactivation' : "'Archivage")),
                        ok:{label: (item_destroyable? 'Supprimer' : (!isArchivage ? 'Désactiver': 'Archiver')),color: 'red'}, cancel: 'Annuler', html: true,
                         message: (item_destroyable ? '<p>Cette opération est irréversible !</p>'+(item.deleted_at ? '<p>Élément actuellement désactivé...</p>' : '')
                                                    : (!isArchivage ? '<p>Cet élément va être désactivé.<br/>Vous pourrez le ré-activer ultérieurement.</p>' : '')
                                                                // +(is_in_regex ? '<p>Attention cependant, cet utilisateur sera automatiquement supprimé définitivement au terme de 60 jours sans l\'avoir restaurer.</p>' : '')
                                ) + msg
                }).onOk(() => {


                    // axios.delete(`${item.delete_url}`)
                    // axios.post(fn.route(route+'.destroy', item.id),{_method: 'DELETE'})
                    proto.$inertia.delete(route(router+'.destroy', item.id),{
                    // // proto.acg.$inertia.post(fn.route(route+'.destroy', {id: item.id, _method: 'DELETE'}),{
                    // .then(() => {

                // //         if(   item_destroyable  // suppression définitive, tables softdelete: users

                // //             // if(     item.deleted_at  // tables softdelete: users
                // //             // || (! item.deleted_at && ! (/user/g).test(item.delete_url) )
                // //         ){
                // //             if( ! _.isArray(target)){ target = _.toArray(target) }

                // //             target.splice(target.indexOf(item), 1)

                // //             fn.notify('info', 'Élément définitivement supprimé.')
                // // // log('2 in deleteItem', item, target)
                // //         }
                // //         else {
                // //             item.deleted_at = Date.now() // softdelete

                // //             fn.notify('info', 'Élément mis en corbeille.')
                // //         }
                //         if(target){
                //             if( ! _.isArray(target)){ target = _.toArray(target) }

                //             target.splice(target.indexOf(item), 1)
                //         }
                    // })
                    // .catch((error) => {
                    onSuccess:()=>{
                        if(target){
                            if( ! _.isArray(target)){ target = _.toArray(target) }

                            target.splice(target.indexOf(item), 1)
                        }

                        appStore().getAllUsers(true)
                    },
                    onError:() => {
                // //         // if(error.response){
                // //         //     _.each(error.response.data.errors, (error_array, error_name)=>{
                // //         //         fn.notify('warning', `Problème sur : ${_.capitalize(error_name)}  ( ${error_array[0]} )`, '', 10000);
                // //         //     });
                // //         // } else {
                            e('ACTIONS EDITION - deleteItem', error)
                        }
                    });

                });


        },
    }
}
